module.exports = __webpack_public_path__ + "static/img/yjj.ce564bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yjj.png
// module id = kPdl
// module chunks = 1